<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.75 1.25H16.25V3.75H18.75V1.25Z" />
    <path d="M18.75 5H16.25V7.5H18.75V5Z" />
    <path d="M15 1.25H12.5V3.75H15V1.25Z" />
    <path d="M15 5H12.5V7.5H15V5Z" />
    <path
      d="M17.5 10V13.75H2.5V3.75H10V2.5H2.5C2.16848 2.5 1.85054 2.6317 1.61612 2.86612C1.3817 3.10054 1.25 3.41848 1.25 3.75V13.75C1.25 14.0815 1.3817 14.3995 1.61612 14.6339C1.85054 14.8683 2.16848 15 2.5 15H7.5V17.5H5V18.75H15V17.5H12.5V15H17.5C17.8315 15 18.1495 14.8683 18.3839 14.6339C18.6183 14.3995 18.75 14.0815 18.75 13.75V10H17.5ZM11.25 17.5H8.75V15H11.25V17.5Z"
    />
  </svg>
</template>
